import { SubmenuItemType } from '../types/elmoMenuModel';

export class AppMenu {
  isOpened: boolean = true;
  currentSubmenuItem: SubmenuItemType | null = null;
}
